import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";

const CrossMark = ({ size = 120 }) => (
  <div
    style={{
      width: size,
      height: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #FCA5A5, #DC2626)",
      borderRadius: "50%",
    }}
    aria-hidden
  >
    <svg
      viewBox="0 0 100 100"
      width={size * 0.6}
      height={size * 0.6}
      style={{ display: "block" }}
    >
      <path
        d="M30 30 L70 70 M70 30 L30 70"
        stroke="#fff"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="120"
        strokeDashoffset="120"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="120"
          to="0"
          dur="0.6s"
          fill="freeze"
        />
      </path>
    </svg>
  </div>
);

const PaymentFailedModal = ({ open, onClose, payload }) => {
  const [confettiOn, setConfettiOn] = useState(false);

  useEffect(() => {
    if (open) {
      setConfettiOn(true);
      const t = setTimeout(() => setConfettiOn(false), 2500);
      return () => clearTimeout(t);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose?.(), 4000);
    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="payment-modal" role="dialog" aria-modal="true">
      {confettiOn && (
        <Confetti
          recycle={false}
          numberOfPieces={80}
          colors={["#ef4444", "#f87171", "#fca5a5"]}
        />
      )}

      <div className="payment-modal-backdrop" onClick={onClose} />
      <div className="payment-modal-content">
        <div className="payment-modal-body">
          <CrossMark />
          <h2 className="payment-modal-title">Payment Failed</h2>
          <p className="payment-modal-subtext">
            Your payment of{" "}
            <span className="font-medium">₹{payload.amount}</span> could not be
            completed.
          </p>

          <div className="payment-modal-info">
            <div className="payment-modal-info-row">
              <div>To</div>
              <div className="font-medium">{payload.receiverName || "---"}</div>
            </div>
            <div className="payment-modal-info-row">
              <div>Date</div>
              <div className="font-medium">
                {payload.time || new Date().toLocaleString()}
              </div>
            </div>
          </div>

          <p className="payment-modal-error-msg">
            {payload.message || "Please try again later."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedModal;
